// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SideContent_wrap__191GJ","name":"SideContent_name__10KvB","link":"SideContent_link__LblTo","image":"SideContent_image__GGfST","container":"SideContent_container__1V7sa"};